import React from 'react'
import { Input, Form, type FormInstance } from 'antd'

const InputFieldNINumber = (props: {
    name: string
    form: FormInstance<any>
}): React.ReactElement => {
    const { name } = props

    const niPattern = /^[A-Z]{2}\s?\d{2}\s?\d{2}\s?\d{2}\s?[A-Z]$/

    return (
        <Form.Item
            label={'NI Number'}
            name={name}
            rules={[
                {
                    pattern: niPattern,
                    message: 'Invalid NI Number format',
                },
            ]}
        >
            <Input
                allowClear
                maxLength={13} // e.g., QQ 12 34 56 C
            />
        </Form.Item>
    )
}

export default InputFieldNINumber
